import ajax from "./ajax";

export const INSERTS_SETTINGS_ID = "inserts";

export const getInsertsSettings = () => ajax("/inserts/settings");

export const getInserts = (params = {}) => {
  const qs = new URLSearchParams();
  if (params.shopId) qs.set("shopId", params.shopId);
  if (params.forSeller) qs.set("forSeller", "true");
  const q = qs.toString();
  return ajax(`/inserts${q ? `?${q}` : ""}`);
};
export const createInsert = (data) =>
  ajax("/inserts", { method: "POST", data });
export const updateInsert = (id, data) =>
  ajax(`/inserts/${id}`, { method: "PUT", data });
export const deleteInsert = (id) =>
  ajax(`/inserts/${id}`, { method: "DELETE" });
export const ensureInsertBlank = (id) =>
  ajax(`/inserts/${id}/ensure-blank`, { method: "POST" });
export const seedInsertsCatalog = () =>
  ajax("/inserts/seed", { method: "POST" });

export const getInsertRules = (params = {}) => {
  const qs = new URLSearchParams();
  if (params.shopId) qs.set("shopId", params.shopId);
  const q = qs.toString();
  return ajax(`/inserts/rules${q ? `?${q}` : ""}`);
};
export const createInsertRule = (data) =>
  ajax("/inserts/rules", { method: "POST", data });
export const updateInsertRule = (id, data) =>
  ajax(`/inserts/rules/${id}`, { method: "PUT", data });
export const deleteInsertRule = (id, data = {}) => {
  const qs = new URLSearchParams();
  if (data.shopId) qs.set("shopId", data.shopId);
  const q = qs.toString();
  return ajax(`/inserts/rules/${id}${q ? `?${q}` : ""}`, {
    method: "DELETE",
  });
};

export const getInsertStorageLocations = () =>
  ajax("/inserts/storage-locations");
export const getInsertStorageLocationMap = () =>
  ajax("/inserts/storage-locations/map");
export const createInsertStorageLocation = (data) =>
  ajax("/inserts/storage-locations", { method: "POST", data });
export const updateInsertStorageLocation = (id, data) =>
  ajax(`/inserts/storage-locations/${id}`, { method: "PUT", data });
export const deleteInsertStorageLocation = (id) =>
  ajax(`/inserts/storage-locations/${id}`, { method: "DELETE" });

export const reResolveOrderInserts = (orderId) =>
  ajax(`/inserts/orders/${orderId}/reresolve`, { method: "POST" });
export const skipOrderInsert = (orderId, data) =>
  ajax(`/inserts/orders/${orderId}/skip`, { method: "POST", data });
export const addOrderInsert = (orderId, data) =>
  ajax(`/inserts/orders/${orderId}/add`, { method: "POST", data });
